import React from "react";
import CompaniesDescriptions from "../../components/companies/CompanyDescription";
import hands from "../../assets/img/forager-financial/hands.svg";
import accounts from "../../assets/img/forager-financial/cuentas.png";
import MainLayout from "../../layouts/MainLayout";

const ForagerFinancial = () => {
  return (
    <MainLayout styleNav={"bg-navy-blue"} showLogo={"hidden"}>
      <CompaniesDescriptions
        logo={require("../../assets/logos/logo-forager-financial.png")}
        styleLogo="w-64"
        map={require("../../assets/img/companies/forager-financial-map.png")}
        link={{
          name: "visit forager financial services",
          href: "https://www.foragerfinancial.com ",
        }}
        description={
          <>
            <div className="flex flex-col gap-5 mb-20 2xl:mb-40">
              <h3 className="text-xl text-navy-blue font-medium">
                international collaboration for localized results
              </h3>
              <p>
                Forager Financial Services Canada was launched in 2022 after the
                realization that so many organizations were having difficulty
                finding qualified and cost-effective accountants to help them
                maintain their financial records. Co-founded with an experienced
                lead accountant from Colombia, Anderson Guerrero, Forager
                Financial Services is able to build a bridge between Canadian
                organizations and qualified Colombian accountants. Sourcing top
                remote talent for any organziation, no matter how remote, is the
                way that Forager Financial Serives is innovating how
                organziations manage their finances.
              </p>
              <p>
                Forging strategic partnerships with associations across Canada,
                Forager Financial Services is set to solve a major hurdle for
                cultural organizations.
              </p>
            </div>
          </>
        }
      />
      <div className="bg-page-foregaer-financial bg-cover bg-no-repeat">
        <div className="lg:container lg:mx-auto grid grid-cols-2 items-center pt-24 xl:py-24 sm:px-4 gap-x-5">
          <div className="col-span-2 md:col-span-1 text-white px-4 sm:px-0">
            <img src={hands} alt="" className="mx-auto xl:mx-0 pb-10" />
            <h1 className="text-xl lg:text-2xl pb-8 font-medium">
              developing respectful <span className="block">employment opportunities</span>
            </h1>
            <p className="pb-16 xl:pb-0">
              Often in Latin America, the thought of work-life balance and
              respectful workplaces by employers is a secondary consideration if
              considered at all. Forager Financial Services was founded on the
              desire to develop training and employment opportunities for
              accountants in Latin America, primarily Colombia, that pays a
              living wage and allows people to develop both healthy professional
              lives as well as personal lives. With each new contract, we are
              able to provide a new opportunity.
            </p>
          </div>
          <div
            style={{ backgroundImage: `url(${accounts})` }}
            className="col-span-2 md:col-span-1 w-full h-[26rem] bg-cover bg-no-repeat md:rounded-xl"
          />
        </div>
      </div>
    </MainLayout>
  );
};

export default ForagerFinancial;
